import { Controller } from "@hotwired/stimulus"

/**
 * Votifier設定コントローラー
 * 
 * 有効化チェックボックスの変更で設定セクションの表示/非表示を切り替え、
 * バージョン選択の変更でV1/V2設定の表示を切り替えます。
 * 
 * Validates: Requirements 4.2, 4.3, 4.4
 */
export default class extends Controller {
  static targets = ["enabledCheckbox", "settingsSection", "v1Settings", "v2Settings"]

  /**
   * コントローラー接続時に初期状態を設定
   */
  connect() {
    this.updateVisibility()
  }

  /**
   * 有効化チェックボックスの変更時に設定セクションの表示/非表示を切り替え
   */
  toggleEnabled() {
    this.updateVisibility()
  }

  /**
   * バージョン選択の変更時にV1/V2設定の表示を切り替え
   */
  toggleVersion(event) {
    const version = event.target.value
    this.updateVersionVisibility(version)
  }

  /**
   * 表示状態を更新
   */
  updateVisibility() {
    const enabled = this.enabledCheckboxTarget.checked
    
    if (enabled) {
      this.settingsSectionTarget.classList.remove("hidden")
      // 現在選択されているバージョンに基づいてV1/V2設定を表示
      const versionSelect = this.settingsSectionTarget.querySelector('select[name*="votifier_version"]')
      if (versionSelect) {
        this.updateVersionVisibility(versionSelect.value)
      }
    } else {
      this.settingsSectionTarget.classList.add("hidden")
    }
  }

  /**
   * V1/V2設定の表示を切り替え
   */
  updateVersionVisibility(version) {
    if (version === "v1") {
      this.v1SettingsTarget.classList.remove("hidden")
      this.v2SettingsTarget.classList.add("hidden")
    } else if (version === "v2") {
      this.v1SettingsTarget.classList.add("hidden")
      this.v2SettingsTarget.classList.remove("hidden")
    }
  }
}
